/**
 * 상태 일러스트 레지스트리 SSoT — 빈 상태·업로드 유도·결제 실패 등 "상태 화면"에만 쓴다.
 * 화면은 키만 넘기고(`<EmptyState illustration="search-none" />`), 파일·출처는 여기와
 * `assets/illustrations/manifest.json` 이 소유한다. UI 글리프(메뉴·버튼)는 lucide 를 유지한다.
 *
 * 원본: IconScout "Empty State" 팩(Corner Pixel, pack 415050) 단일 팩. 색은 시맨틱 토큰 CSS 변수
 * (`--foreground`·`--card`·`--primary`)로 치환돼 있어 다크 토큰을 따라간다 — 규칙은 DESIGN.md.
 */
import EmptyCalendar from '@/assets/illustrations/empty-calendar.svg?react';
import EmptyCompany from '@/assets/illustrations/empty-company.svg?react';
import EmptyMatch from '@/assets/illustrations/empty-match.svg?react';
import EmptySubscription from '@/assets/illustrations/empty-subscription.svg?react';
import FilterNone from '@/assets/illustrations/filter-none.svg?react';
import PaymentFail from '@/assets/illustrations/payment-fail.svg?react';
import SearchNone from '@/assets/illustrations/search-none.svg?react';
import UploadDoc from '@/assets/illustrations/upload-doc.svg?react';

export const ILLUSTRATIONS = {
  /** 등록된 업체 없음(첫 진입 온보딩). */
  'empty-company': EmptyCompany,
  /** 키워드 검색 0건. */
  'search-none': SearchNone,
  /** 필터 조건 0건. */
  'filter-none': FilterNone,
  /** 파일 업로드 유도(드롭존). */
  'upload-doc': UploadDoc,
  /** 일정 없음. */
  'empty-calendar': EmptyCalendar,
  /** 판정·매칭 결과 없음. */
  'empty-match': EmptyMatch,
  /** 구독·결제 내역 없음. */
  'empty-subscription': EmptySubscription,
  /** 결제·결제수단 처리 실패. */
  'payment-fail': PaymentFail,
} as const;

export type IllustrationKey = keyof typeof ILLUSTRATIONS;
